<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">Misdeal!</div>
    <div class="details">
        <img src="assets/img/misdeal-logo.webp" alt="Misdeal Logo" class="misdeal-logo"/>
        <div class="sopo-popup-text">
            <span>A fresh hand is on the way.</span>
            <span>Good Luck!</span>
        </div>
    </div>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button" (click)="dismiss()">OK</div>
    </div>
</div>
